<template lang="pug">
button.btn(
  type="button"
  :class="{ active: selected }"
  :value="value"
  :disabled="disabled"
  @click.prevent="onClick"
)
  span.a-tooltip(
    v-if="showDisabledTooltip"
    v-tooltip="disabledTooltipOptions"
    :title="disabledTooltip"
  )
    | {{ text }}
  span(v-else)
    | {{ text }}
</template>

<script>
export default {
  name: 'AppToggleButton',
  props: {
    value: {
      type: [String, Number, Boolean],
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTooltip: {
      type: String,
      default: '',
    },
    disabledTooltipOptions: {
      type: Object,
      default: () => {
        return {
          placement: 'bottom',
        };
      },
    },
  },
  emits: ['input'],
  computed: {
    showDisabledTooltip() {
      return this.disabled && this.disabledTooltip.length;
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('input', this.value);
      }
    },
  },
};
</script>
